import React, {useState} from "react";
import {createRoot} from "react-dom/client";
import {useTranslation} from "react-i18next";

interface IItemData {
  itemId: string;
  name: string;
  quantity: number;
  media1x: string;
  media2x: string;
}

export class ProductBundleHandler {
  public static run(element: HTMLDivElement): void {
    const subItemsDiv = element.querySelectorAll<HTMLDivElement>(".sub-item-data-container");
    const subItems = Array.from(subItemsDiv).map<IItemData>((subItem) => ({
      itemId: subItem.dataset.subItemId ?? "",
      name: subItem.dataset.subItemName ?? "",
      quantity: Number(subItem.dataset.subItemQuantity || "0"),
      media1x: subItem.dataset.subItemMediaIdSingle ?? "",
      media2x: subItem.dataset.subItemMediaIdDouble ?? "",
    }));

    const root = createRoot(element);
    root.render(<ProductBundleBlock place={element.dataset.place} subItems={subItems} />);
  }
}

const ProductBundleBlock: React.FC<{place?: string; subItems: IItemData[]}> = ({subItems}) => {
  const [expandContent, setExpandContent] = useState(false);
  const {t} = useTranslation();
  const bundleItemsPresent = subItems.length;

  return (
    <React.Suspense fallback={null}>
      <div className="product-bundle-block">
        <h2 className="product-bundle-block__title">{t("product.preconfiguredForYou")}</h2>
        <div
          className={`product-bundle-block__wrapper ${
            expandContent || bundleItemsPresent <= 4
              ? "product-bundle-block__wrapper--isExpanded"
              : "product-bundle-block__wrapper--isCollapsed"
          }`}
        >
          {subItems.map((subItem, index) => (
            <div key={index} className="product-bundle-block__product">
              <img
                className="product-bundle-block__product-image"
                src={subItem.media1x}
                srcSet={`${subItem.media1x} 1x, ${subItem.media2x} 2x`}
                alt={subItem.name}
                loading="lazy"
              />
              <h4 className="product-bundle-block__product-name">{subItem.name}</h4>
              <p className="product-bundle-block__product-quantity">
                {t("product.items--quantity", {quantity: subItem.quantity})}
              </p>
            </div>
          ))}
        </div>
      </div>
      {bundleItemsPresent > 4 && (
        <div className="product-bundle-block__toggle">
          <a
            onClick={(e) => {
              e.preventDefault();
              setExpandContent(!expandContent);
            }}
            className="product-bundle-block__link"
          >
            {expandContent ? t("product.collapse") : t("product.showAll")}
          </a>
        </div>
      )}
    </React.Suspense>
  );
};
